export default __webpack_public_path__ + "static/media/ep3collage5.853bec55.jpg";